import React from 'react';
import styled from 'styled-components';
import MessageGroup from './MessageGroup';

import { TAppElkMessage } from 'TProtocol/prototypes/events/messages';
import { ShadedBox } from '../pages/BasePage';

const EventPageMessages = ({ messages }: { messages: TAppElkMessage[] }) => {
  const count = messages.length;

  return <ShadedBox>
      <MessageTitle>
        Messages from host
      </MessageTitle>
      <MessageGroup messages={messages}/>
  </ShadedBox>;

};

const MessageTitle = styled.div`
  padding: 10px;
`;

export default EventPageMessages;
